import { Box } from '@mui/material'
import { useMinimalsTheme } from '@tom-ui/ui'

export const WavePattern = () => {
  const theme = useMinimalsTheme()

  const wave = theme.palette.grey[500]
  const waveLength = 40
  const amplitude = 4
  const strokeWidth = 2

  const waveLine = (yOffset: number) => {
    const points: string[] = []
    for (let x = 0; x <= waveLength; x++) {
      const y = yOffset + amplitude * Math.sin((2 * Math.PI * x) / waveLength)
      points.push(`${x},${y.toFixed(2)}`)
    }
    return points.join(' ')
  }

  const svgWave = encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" width="${waveLength}" height="50">` +
      `<polyline points="${waveLine(12)}" fill="none" stroke="${wave}" stroke-width="${strokeWidth}"/>` +
      `<polyline points="${waveLine(25)}" fill="none" stroke="${wave}" stroke-width="${strokeWidth}"/>` +
      `<polyline points="${waveLine(38)}" fill="none" stroke="${wave}" stroke-width="${strokeWidth}"/>` +
      `</svg>`,
  )

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        borderRadius: 'inherit',
        overflow: 'hidden',
        backgroundImage: `url("data:image/svg+xml,${svgWave}")`,
        backgroundRepeat: 'repeat-x',
        backgroundSize: `${waveLength}px 100%`,
      }}
    />
  )
}
